import { GetterTree } from 'vuex';

import { RootState, ListStatus } from '@/store/types';
import { createEditableGetters } from '@/store/utils/editable';

import { EventsState } from './types';

const {
  isLoading: editableIsLoading,
  isLoaded: editableIsLoaded,
  isSaving: editableIsSaving,
  isSaved: editableIsSaved,
  isFailed: editableIsFailed,
  hasUnsavedChanges: editableHasUnsavedChanges,
} = createEditableGetters<EventsState>('editableStatus', 'editable', 'initialEditable');

export const moduleGetters: GetterTree<EventsState, RootState> = {
  /**
   * List
   */
  listIsLoading: (state) => state.listStatus === ListStatus.Loading,
  listIsLoaded: (state) => state.listStatus === ListStatus.Loaded,
  listIsError: (state) => state.listStatus === ListStatus.Failed,
  listIsEmpty: (state, getters) => getters.listIsLoaded && !state.list.length,

  /**
   * Edit
   */
  editableIsLoading,
  editableIsLoaded,
  editableIsSaving,
  editableIsSaved,
  editableIsFailed,
  editableHasUnsavedChanges,
};

export default moduleGetters;
